export default function ({app, redirect}) {
  if(!app.$isRoot()) {
    return redirect(302, '/dashboard');
  }
}